module.exports = __webpack_public_path__ + "static/media/Boxer.ef4f6a73.png";